import { render, staticRenderFns } from "./GraphicsEdadGenero.vue?vue&type=template&id=3a6ef9b2&scoped=true&"
import script from "./GraphicsEdadGenero.vue?vue&type=script&lang=js&"
export * from "./GraphicsEdadGenero.vue?vue&type=script&lang=js&"
import style0 from "./GraphicsEdadGenero.vue?vue&type=style&index=0&id=3a6ef9b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6ef9b2",
  null
  
)

export default component.exports